export default __webpack_public_path__ + "static/section_6_details_3-f19bc568dbae4d170a120cd6999bddea.png";